import React, { memo } from 'react';
import { FormSection, FormInput } from '@/components';
import { CreateResourceFormData, CreateResourceFormErrors } from '@/components/admin/resources/CreateResource/hooks/useCreateResourceForm';
import { IconSelector } from './IconSelector';

interface ResourceDetailsSectionProps {
  formData: CreateResourceFormData;
  errors: CreateResourceFormErrors;
  onFieldChange: (field: keyof CreateResourceFormData, value: string) => void;
}

export const ResourceDetailsSection = memo<ResourceDetailsSectionProps>(({
  formData,
  errors,
  onFieldChange,
}) => {
  return (
    <FormSection 
      title="Resource Details"
      subtitle="Basic information about your resource"
    >
      <IconSelector
        selectedIcon={formData.icon}
        onIconSelect={(icon) => onFieldChange('icon', icon)}
        error={errors.icon}
      />
      
      <FormInput
        label="Resource Name"
        value={formData.name}
        onChangeText={(value) => onFieldChange('name', value)}
        placeholder="Enter resource name"
        error={errors.name}
        required
        autoCapitalize="sentences"
        autoCorrect={false}
      />
      
      <FormInput
        label="Description"
        value={formData.description}
        onChangeText={(value) => onFieldChange('description', value)}
        placeholder="Describe your resource"
        error={errors.description}
        required
        multiline
        numberOfLines={4}
        autoCapitalize="sentences"
        autoCorrect
      />
    </FormSection>
  );
});

ResourceDetailsSection.displayName = 'ResourceDetailsSection';